import { MonthArray } from '../../Models/MonthArray';

export function GetDaysInMonth(monthString: string, year: number) {
    // Accepts a string that will be checked against the MonthArray to ensure validity
    // Will return -1 if the month string passed-in doesn't match the month array
    var monthIndex = MonthArray.indexOf(monthString);
    
    // +1 to index as Month Array is zero indexed, but javascript months are 1 indexed
    return monthIndex === -1 ? -1 : new Date(year, monthIndex + 1, 0).getDate();
}